exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-49da97bd] {\n  max-width: 400px;\n}\n.team-member[data-v-49da97bd]  label {\n  top: -15px !important;\n}\n.team-member[data-v-49da97bd]  .vs__selected,\n.team-member[data-v-49da97bd]  input.vs__search {\n  padding-left: 0px;\n  margin-left: -2px;\n}\n.team-member[data-v-49da97bd]  .vs__clear {\n  display: none;\n}\n.create-trip-layout[data-v-49da97bd]  label {\n  left: 0px !important;\n}\n.create-trip-layout[data-v-49da97bd]  .md-clear {\n  display: none;\n}\n.create-trip-layout[data-v-49da97bd]  .md-layout-item {\n  padding-left: 0px;\n}\n", ""]);

// exports
